import React from 'react';
import { Grid } from '@mui/material';
import { Body1, H1, Subtitle1 } from '../../../components/typography/typography';
import { PrimaryButton } from '../../../components/buttons/buttons';
import SearchInput from '../../../components/inputs/searchInput';
import { useTranslation } from 'react-i18next';
import CustomCard from '../../../components/card/CustomCard';
import SelectInput from '../../../components/inputs/selectInput';
import { enumToOptions } from '../../../utils/misc';
import { OfferQueryActive, OfferQueryStrategy } from '../../../models/offerQuery';

interface Props {
  setIsOpen: (value: boolean) => void,
  handleQuery: (query: {
    search?: string;
    strategy?: string;
    active?: boolean;
  }) => void
}

const Header: React.FC<Props> = ({
  setIsOpen,
  handleQuery
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={8}>
          <H1>{t('Offer Queries')}</H1>
          <Subtitle1>{t('List of offer queries:')}</Subtitle1>
        </Grid>
        <Grid size={4}>
          <Body1 align='right'>
            <PrimaryButton onClick={() => setIsOpen(true)}>{t('Add Query')}</PrimaryButton>
          </Body1>
        </Grid>
      </Grid>
      <CustomCard>
        <Grid container spacing={2} marginY={1}>
          <Grid size={4}>
            <SearchInput onChange={search => handleQuery({ search })} />
          </Grid>
          <Grid size={4}>
            <SelectInput
              label={t('Strategy')}
              onChange={(e) => { handleQuery({ strategy: e.target.value }); }}
              options={enumToOptions(OfferQueryStrategy)}
            />
          </Grid>
          <Grid size={4}>
            <SelectInput
              label={t('Active')}
              onChange={(e) => { handleQuery({ active: e.target.value ? true : false }); }}
              options={enumToOptions(OfferQueryActive)}
            />
          </Grid>
        </Grid>
      </CustomCard>
    </>
  );
};

export default Header;
